<template>
  <div v-if="pageDisplay === 'booking'">
    <div
        id="hab-main-layout"
        :class="[
      'hab-main-layout',
      {
        [`${locale}`]: locale,
        'hab-main-layout-intro': !isPaymentStep && isTicketMain,
      },
    ]"
    >
      <div class="container">
        <CompListEmpty v-if="isErrorServer" :is-error-server="isErrorServer" />
        <template v-else>
          <Payment v-if="isPaymentStep" />
          <CompTopFilter v-if="!isPaymentStep" />
          <CompFlex
              v-if="!isPaymentStep && !isTicketMain"
              className="main-layout-home"
              gap="14"
              class="mt-24"
          >
            <div class="left">
              <CompLeftFilter
                  :key="componentKey"
                  :dataStatistic="route_filter_statistic"
              />
            </div>
            <div class="main">
              <template v-if="route_data.length !== 0">
                <div class="main-layout-home__title">
                  {{ title }}
                </div>
                <!--          <div class="main-layout-home__filter-top">-->
                <!--            {{ $t("common.order_by_label") }}: Giờ đi sớm nhất | Giờ đi muộn-->
                <!--            nhất | Giá tăng dần | Giá giảm dần-->
                <!--          </div>-->
              </template>
              <CompList v-if="route_data.length !== 0" :data="route_data" />
              <CompListEmpty
                  v-else-if="!loading_list"
                  :empty-content="emptyContent"
              />
              <CompListLoading v-if="loading_list" />
              <div
                  v-if="total_pages > 1 && page !== total_pages && !loading_list"
                  class="main-layout-home__pagination"
              >
                <span @click="handelLoadMore">{{ $t("common.load_more") }}</span>
              </div>
            </div>
          </CompFlex>
          <!-- <CompExample /> -->
          <!-- <button v-on:click="testSendMail">send</button> -->
        </template>
      </div>
    </div>
  </div>
  <div v-else>
    <TicketInfo />
  </div>
</template>

<script>
import CompFlex from "./components/flex/index.vue";
import CompTopFilter from "./components/molecules/top-filter/index.vue";
import CompLeftFilter from "./components/molecules/left-filter/index.vue";
import CompList from "./components/molecules/list/index.vue";
import CompListLoading from "./components/molecules/list/loading";
import CompListEmpty from "./components/molecules/list/empty";
import Payment from "./components/molecules/payment/index";
import TicketInfo from "./components/molecules/ticket-info/index";
import { get, isEmpty } from "lodash";
import {toConvertDateFromString, toConvertNameNonAccentVN} from "./utils/helpers";

export default {
  components: {
    CompFlex,
    CompTopFilter,
    CompLeftFilter,
    CompList,
    CompListLoading,
    CompListEmpty,
    Payment,
    TicketInfo
  },
  data() {
    return {
      options: [
        {
          label: "name",
          value: "value",
        },
      ],
      page: 1,
      page_size: 20,
      total: 0,
      total_pages: 1,
      route_data: [],
      area_data: {},
      loading_list: true,
      route_filter_statistic: null,
      componentKey: 0,
      locale: locale,
      isTicketMain: isTicketMain
    };
  },
  computed: {
    nameFrom() {
      if (isEmpty(this.area_data)) {
        return "";
      }

      let name = get(this.area_data, "from.name", "");
      const city = get(this.area_data, "from.city", {});
      if (!isEmpty(city)) {
        const stateName = get(this.area_data, "from.state.name", "");
        if (stateName) {
          name += " - " + stateName;
        }
      }

      return name;
    },
    nameTo() {
      let name = get(this.area_data, "to.name", "");
      const city = get(this.area_data, "to.city", {});
      if (!isEmpty(city)) {
        const stateName = get(this.area_data, "to.state.name", "");
        if (stateName) {
          name += " - " + stateName;
        }
      }

      return name;
    },
    title() {
      if (isEmpty(this.area_data)) {
        return "";
      }
      const newDate = toConvertDateFromString(bookingDate);
      return this.$t("common.list_title", {
        from:
          this.$i18n.locale === "vn"
            ? this.nameFrom
            : toConvertNameNonAccentVN(this.nameFrom),
        to:
          this.$i18n.locale === "vn"
            ? this.nameTo
            : toConvertNameNonAccentVN(this.nameTo),
        total: this.total,
        date: this.$i18n.locale === "vn" ? newDate.format("DD/MM/YYYY") : newDate.format("DD MMMM YYYY")
      });
    },
    emptyContent() {
      return this.$t("common.result_empty_content_2", {
        route:
          this.$i18n.locale === "vn"
            ? this.nameFrom + " - " + this.nameTo
            : toConvertNameNonAccentVN(this.nameFrom) +
              " - " +
              toConvertNameNonAccentVN(this.nameTo),
        date: bookingDate,
      });
    },
    isPaymentStep() {
      return this.$store.state.booking.is_payment_step;
    },
    isErrorServer() {
      return this.$store.state.auth.is_error_server;
    },
    pageDisplay() {
      return pageDisplay || 'booking'
    }
  },
  async created() {
    if (!this.$store.getters.isLoggedIn) {
      await this.authenticate();
    }

    if (this.pageDisplay !== 'booking') {
      return
    }

    this.requestRoutes();
    this.fetchCities();
    this.requestRouteFilterStatistic();
  },
  methods: {
    authenticate: async function () {
      await this.$store
        .dispatch("authenticate", {})
        .then((result) => {
          const data = get(result, "data");

          if (!data) {
            this.$store.commit("setIsErrorServer", true);
          }
        })
        .catch((e) => {
          this.$store.commit("setIsErrorServer", true);
        });
    },
    forceRerender() {
      this.componentKey += 1;
    },
    getTimes() {
      const bookingTimesArr = bookingTimes.split(",");
      if (bookingTimes && bookingTimesArr?.length !== 0) {
        return {
          time: {
            min: bookingTimesArr[0],
            max: bookingTimesArr[1],
          },
        };
      }

      return {};
    },
    getFares() {
      const bookingFaresArr = bookingFares.split(",");
      if (bookingFares && bookingFaresArr?.length !== 0) {
        return {
          fare: {
            min: bookingFaresArr[0],
            max: bookingFaresArr[1],
          },
        };
      }

      return {};
    },
    getCompanies() {
      const params = new URLSearchParams(window.location?.search);
      const newP = params.getAll("companies");
      return {
        companies: newP
      }
    },
    getFilter() {
      return {
        online_ticket: 1,
        from: bookingFrom,
        to: bookingTo,
        date: bookingDate,
        ...(bookingRating
          ? {
              rating: {
                min: bookingRating,
                max: 5,
              },
            }
          : {}),
        ...this.getTimes(),
        ...this.getFares(),
        ...this.getCompanies(),
      };
    },
    requestRoutes() {
      this.loading_list = true;
      const params = {
        filter: this.getFilter(),
        page: this.page,
        pagesize: this.page_size,
        locate: this.$i18n.locale
      };

      this.$store
        .dispatch("getRouteList", params)
        .then((result) => {
          const data = get(result, "data", {});
          this.loading_list = false;
          if (!data) {
            this.$store.commit("setIsErrorServer", true);

            return;
          }

          // SEO
          // this.updateSeoTicketBooking(data.area)
          this.area_data = data.area || {};
          this.route_data.push(...(data.data || []));
          this.total = data.total;
          this.total_pages = data.total_pages;
        })
        .catch(() => {
          this.$store.commit("setIsErrorServer", true);
        });
    },
    requestRouteFilterStatistic() {
      const params = {
        filter: this.getFilter(),
        page: this.page,
        pagesize: this.page_size,
      };

      this.$store.dispatch("getRouteStatistic", params).then((result) => {
        this.route_filter_statistic = result.data.data;
        this.forceRerender();
      });
    },
    fetchCities() {
      this.$store.dispatch("getCities");
    },
    handelLoadMore() {
      this.page++;
      this.requestRoutes();
    },
    testSendMail() {
      this.$store.dispatch("sendMail").then((result) => {
        console.log(result);
      });
    },
    getNameCity(areaValue, type = 'from') {
      if (isEmpty(areaValue)) {
        return "";
      }

      let name = get(areaValue, type + ".name", "");
      const city = get(areaValue, type + ".city", {});
      if (!isEmpty(city)) {
        const stateName = get(areaValue, type + ".state.name", "");
        if (stateName) {
          name += " - " + stateName;
        }
      }

      return name;
    },
    async updateSeoTicketBooking(area) {
      try {
        const fromName = this.getNameCity(area);
        const toName = this.getNameCity(area, "to");
        const fromId = area?.from?.id;
        const toId = area?.to?.id;
        if (!fromId && !toId) {
          return;
        }

        fetch(appUrl + "/api/seo-ticket-booking", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            lang_code: this.$i18n.locale,
            fromId,
            toId,
            fromName,
            toName,
          }),
        })
          .then((response) => response.json())
          .then((data) => {})
          .catch((error) => {
            throw new Error(error);
          });
      } catch (error) {
        console.log("Request failed", error);
      }
    },
  },
};
</script>
